import React from "react";
import { Filter } from "lucide-react";
import { Form, FormField } from "components/ui/form";
import { cn } from "lib/utils";
import { useForm } from "react-hook-form";
import { InputGs } from "components/ui/Forms/inputGs";
import { Button } from "components/ui/ButtonGs";
import { useFilterStore, IFilterFields } from "store/hub/hubChecklistUser";

interface DataFilterProps {
  className?: string;
}

export const DataFilter: React.FC<DataFilterProps> = ({ className }) => {
  const [isOpened, setIsOpened] = React.useState<boolean>(false);
  const { filtersData, setFiltersData, clearFilters } = useFilterStore();

  const form = useForm({
    defaultValues: filtersData,
  });

  const onFilter = (fields: IFilterFields) => {

    setFiltersData({ ...fields});
  };

  const handleClear = React.useCallback(() => {
    form.reset();
    clearFilters();
    setIsOpened(false);
  }, [clearFilters, form]);

  return (
    <div
      className={cn(
        "flex flex-col w-max rounded-md px-6 py-4 bg-white shadow-sm shadow-slate-300 duration-300 transition-all",
        className,
        isOpened && "w-full"
      )}
    >
      <button
        onClick={() => {
          setIsOpened(!isOpened);
        }}
        className="group flex gap-2 items-center duration-300 transition-all"
      >
        <Filter
          className={cn(
            "cursor-pointer group-hover:fill-black transition-all duration-300",
            isOpened && "fill-black"
          )}
          size={14}
        />
        <span className="text-slate-600 text-sm">Filtrar</span>
      </button>
      {isOpened && (
        <div id="filterForm" className="border-t-slate-300 border-t pt-3 mt-4 ">
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onFilter)}>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
    
                <FormField
                  name="name"
                  control={form.control}
                  render={({ field }) => (
                    <InputGs {...field} label="Nome" />
                  )}
                />
                <FormField
                  name="email"
                  control={form.control}
                  render={({ field }) => (
                    <InputGs
                      {...field}
                      value={field.value ?? ""}
                      label="Email"
                    />
                  )}
                />
              </div>
              <div className="flex justify-end w-full gap-4">
                <Button.Root
                  variant="secondary"
                  size="sm"
                  type="button"
                  onClick={handleClear}
                >
                  Limpar filtro
                </Button.Root>
                <Button.Root
                  variant="primary"
                  size="sm"
                  type="submit"
                  disabled={false}
                >
                  Buscar
                </Button.Root>
              </div>
            </form>
          </Form>
        </div>
      )}
    </div>
  );
};
